import { css, useTheme } from '@emotion/react';

export default function useStyle() {
  const theme = useTheme();

  const { primary, background } = theme.palette;
  const { fontFamily } = theme.typography;
  const { lg } = theme.breakpoints;

  const base = css`
    background-color: ${background.default};
    padding: 10px;
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;

    @media (min-width: 640px) {
      padding: 0 15px 15px;
    }

    @media (min-width: ${lg}px) {
      padding: 0 50px 50px;
    }

    .container {
      margin: 0 auto;
      margin-bottom: 10px;
    }

    & .container > div {
      background-color: ${background.gray3};
      padding: 35px 25px;
      border-radius: 15px;
    }

    & h2 {
      display: flex;
      flex-direction: row;
      align-items: flex-start;

      margin: 0;
      padding: 0;

      font-family: Poppins, ${fontFamily};
      font-size: 24px;
      line-height: 30px;

      & img {
        height: 33px;
        margin-bottom: 7px;
        transform: translateY(-7px);
      }
    }

    & .mobile-only {
      display: block;

      @media (min-width: 768px) {
        display: none;
      }
    }

    & .header-flex {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      font-size: 16px;
    }

    & .desktop-only {
      display: none;

      @media (min-width: 768px) {
        display: block;
      }
    }

    & .affirm-logo {
      margin-bottom: 4px;
      margin-left: 4px;

      @media (min-width: 768px) {
        margin-bottom: 10px;
      }
    }

    & p {
      font-family: Poppins, ${fontFamily};
      font-style: normal;
      font-weight: 300;
      font-size: 14px;
      line-height: 18px;
      color: ${primary.main};
    }

    & .affirm-copy {
      width: 100%;
      max-width: 720px;
      margin: 0 auto;

      & a {
        color: ${primary.main};
        text-decoration: underline;
        text-underline-offset: 2px;
        font-weight: 500;
        margin-left: 10px;
      }
    }

    @media (min-width: 768px) {
      & h2 {
        display: flex;
        font-size: 32px;
        line-height: 39px;
        flex-direction: row;
        justify-content: center;
        gap: 8px;
        align-items: center;

        & img {
          height: 43px;
          transform: translateY(-8px);
        }
      }
      & p {
        text-align: center;
        font-size: 16px;
        line-height: 21px;
      }
    }

    @media (min-width: 1024px) {
      & img {
        height: 52px;
      }
    }
  `;

  return {
    base,
  };
}
